// main color
// ========================adjustable color======================
export const ColorPrimary = "#F16F24";
export const ColorPrimaryBtnHover = "#C65412";
export const ColorSecondary = "#FFF4EE";
export const ColorSecondaryHover = "#F5DED1";
export const ColorTertiari = "#18B430";
export const ColorTertiariHover = "#029117";
export const ColorQuartenari = "#FFF8F4";
export const ColorDisabled = "#B7B7B7";
export const ColorGrey = "#DCE5EB";

// background link Email Help Center
export const backgroundLinkElement = "#FFE9DE";

// background all divider
export const divider = "#E8E5E4";

// color hightlight Leaderboards
export const colorPrimarySoft = "#FFEBDD";

export const NavHomeSwiper = "#ECECEC";

// background table header Learderboards
export const columnTitleLeaderboards = "#E7ECEF";

// color title header table leaderboard
export const colorTextTitleLeaderboard = "#292929";

export const colorTextNotFound = "#FFB200";
export const badgeNewBackground = "#F16F24";

// background Linear
export const backgroundLinear1 = "#F16F24";
export const backgroundLinear2 = "linear-gradient(315deg, #F16F24, #E68309)";

// background Popup Earn Rewards
export const backgroundLinearPopupReward1 = "#F16F24";
export const backgroundLinearPopupReward2 = "linear-gradient(315deg, #F16F24, #E68309)";

// ==============================================================

export const ColorBorderSecondary = ColorPrimary;

// color general usage
export const colorTextTitle = "#292929";
export const colorTextTitleMobile = "#212121";
export const colorTextDesc = "#67686D";
export const colorTextList = "#AAAAAD";
export const colorTextSearchInput = "#AAAAAD";
export const colorAlertRedLight = "#FFEEEE";
export const colorAlertRedDark = "#C2272E";
export const colorTransparentBackgroundGrey = "#ECECEC";
export const colorWarningOrangeLight = "#FEB50D";
export const backgroundCard = "#FFFFFF";
export const backgroundThumbCarousel = "#FFFFFF";
export const colorBorderInputForm = "#DCE0EA";
export const colorBorderErrorInputForm = "#C2272E";
export const greyFormInput = "#DCE0EA";
export const colorTextInput = "#292929";
export const iconCheckColor = "#27CA40";
export const textUserPhoto = "#FFFFFF";
export const iconGeneralBackground = "#ECECEC";
export const iconGeneralColor = "#292929";
export const colorHoverRed = "#AA141A";
export const colorLink = "#0563C1";
export const linkHover = "#0000EE";
export const whiteSoft = "#E8FBEC";
export const whiteCream = "#FCEEEE";
export const yellowStar = "#FFC401";
export const whiteMore = "#E5E5E6";
export const greenProgress = "#19C433";
export const orangeLight = "#F6AD42";

// home
export const textTitleHome = colorTextTitle;
export const textTitleDesc = colorTextDesc;
export const textMenu = colorTextList;
export const underFiveDaysLeft = colorAlertRedDark;
export const aboveFiveDaysLeft = colorWarningOrangeLight;
export const cardBackground = backgroundCard;
export const progressBarCircle = greenProgress;
export const progressBarLine = greenProgress;
export const slickThumbColor = backgroundThumbCarousel;
export const homeBackground = ColorQuartenari;
export const colorAlertExpiring = colorAlertRedDark;
export const backgroundDisabledArrow = NavHomeSwiper;
export const backgroundDisabledButton = NavHomeSwiper;
export const backgroundCardOngoingCourse = backgroundCard;
export const backgroundCardNewProgra = backgroundCard;
export const backgroundCardExpiring = backgroundCard;
export const backgroundCardOngoingProgram = backgroundCard;

// header
export const textTitleHeader = colorTextTitle;
export const textDescHeader = colorTextDesc;
export const textDropdownHeader = colorTextList;
export const textSearchHeader = colorTextSearchInput;
export const textChangePasswordHeader = colorTextSearchInput;
export const colorAlertChangePassword = colorAlertRedDark;
export const colorAlertLogout = colorAlertRedDark;
export const colorButtonLogOut = ColorPrimary;
export const colorPhotoProfileUserHeader = ColorTertiariHover;

// my learning journey
export const textTitleMyLearningJourney = colorTextTitle;
export const textDescMyLearningJourney = colorTextDesc;
export const textListModule = colorTextList;
export const backgroundModuleWarning = colorAlertRedLight;
export const textModuleWarning = colorAlertRedDark;
export const badgeDaysLeftBackground = colorAlertRedDark;
export const iconCheckModuleBackground = ColorTertiari;
export const listCourseBackground = ColorQuartenari;
export const colorAlertOverdueJourney = colorAlertRedDark;
export const colorDividerModule = colorTransparentBackgroundGrey;
export const colorArrowCollapsedCourse = colorTransparentBackgroundGrey;
export const colorBackgroundChevronCollapse = iconGeneralBackground;
export const colorIconChevronCollapse = iconGeneralColor;
export const dividerListCourseColor = divider;
export const dividerJourneyColor = divider;
export const dividerListModuleColor = divider;
export const progressLineListModuleColor = divider;

// play module
export const btnFullScreenColor = ColorPrimary;
export const btnFullScreenBackground = ColorSecondary;
export const textDescPlayModule = colorTextDesc;
export const textAlertQuit = colorAlertRedDark;

//login
export const borderInputLogin = colorBorderInputForm;
export const borderInputLoginFocus = ColorPrimary;
export const borderErrorInputLogin = colorBorderErrorInputForm;
export const switchOnLogin = ColorTertiari;

//forgot password
export const borderInputForgotPassword = colorBorderInputForm;
export const borderErrorInputForgotPassword = colorBorderErrorInputForm;
export const textDescriptionForgotPassword = colorTextDesc;
export const textInputForgotPassword = colorTextInput;
export const emailTextForgotPassword = colorTextTitle;
export const countDownForgotPassword = colorAlertRedDark;
export const textTitleForgotPassword = colorTextTitle;

//change password
export const borderInputChangePassword = colorBorderInputForm;
export const borderErrorInputChangePassword = colorBorderErrorInputForm;
export const textInputChangePassword = colorTextInput;
export const textTitleChangePassword = colorTextTitle;
export const textDescriptionChangePassword = colorTextDesc;

//modal change password
export const checkCircleIcon = iconCheckColor;

//temporary password
export const textTitleTemporaryPassword = colorTextTitle;
export const textDescriptionTemporaryPassword = colorTextDesc;
export const emailTextTemporaryPassword = colorTextTitle;

// user profile
export const textTitleProfile = colorTextTitle;
export const textDescProfile = colorTextDesc;
export const colorCloseIconProfile = colorTransparentBackgroundGrey;
export const colorBackgroundTab = backgroundCard;
export const colorBackgroundBtnHover = backgroundCard;
export const colorBackgroundBtnCameraProfile = ColorSecondary;
export const borderButtonExportProfile = ColorPrimary;
export const colorIconCameraProfile = ColorPrimary;
export const colorBackgroundWrapper = backgroundCard;
export const textSelectedTabs = ColorPrimary;
export const colorTabsIndicator = ColorPrimary;
export const borderBtnFocus = ColorPrimary;
export const colorBackgroundPhotoProfileUser = ColorTertiariHover;
//export profile
export const backgroundDetailExportProfile = ColorQuartenari;
export const backgroundBodyExportProfile = backgroundCard;
export const titleTextExportProfile = colorTextTitle;
export const descTextExportProfile = colorTextDesc;
export const colorUserPhotoExportProfile = ColorTertiariHover;
export const textUserPhotoExportProfile = textUserPhoto;

//help center
export const colorBackgroundMenuHelpTopics = ColorQuartenari;
export const emailBackroundHelpTopics = backgroundLinkElement;
export const textDescHelpTopics = colorTextDesc;
export const textTitleHelpTopics = colorTextTitle;
export const textEmailHelpTopics = ColorPrimary;
export const backgroundContentHelpTopics = backgroundCard;
export const backgroundHeaderContentHelpTopics = ColorPrimary;
export const headerBgListItemHelpTopics = backgroundCard;
export const contentBgListItemHelpTopics = backgroundCard;
export const textTitleItemHelpTopics = ColorPrimary;
export const linkEmailText = ColorPrimary;

//team monitoring
export const checkBoxColor = ColorPrimary;
export const progressCompleteColor = iconCheckColor;
export const whiteColor = backgroundCard;
export const teamMonitoringText = colorTextTitle;
export const borderShowTeam = ColorPrimary;
export const backgroundBorderShowTeam = ColorSecondary;
export const closeIconBackground = iconGeneralBackground;
export const overDueDate = colorAlertRedDark;
export const progressBarTeamMonitoring = greenProgress;
export const notConfirmedColorText = orangeLight;

// reviews
export const headBadge100 = whiteSoft;
export const headBadgeNot100 = whiteCream;

// modal rating
export const colorStar = yellowStar;
export const colorBodyRating = greyFormInput;

// content library
export const borderColorCollapseCL = whiteMore;
